import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Accordion from "../Accordion/accordion";
import { logout } from "../../redux/actions/actionLogin";


export default function NavBar() {

  const dispatch = useDispatch();
  const navigate= useNavigate();
  const user = useSelector(state => state.auth.user);
  console.log(user);

  const handleLogout = () => {
    dispatch(logout())
    navigate('/login')
  }
  

  return (
    
      <div className="w-[150px] text-yellow-500">   
      {user === undefined || !user.type || user.type[0] === 'user' ?
        <div>
          <div>
            <Accordion
              titulo={<div className="font-semibold">Clientes</div>}
              opciones={
                <div>
                  <ul>
                    <Link to="clientes/listado">
                      <li>Informes</li>
                    </Link>
                    <Link to="clientes/create">
                      <li>Nuevo Cliente</li>
                    </Link>
                  </ul>
                </div>
              }
            />
          </div>
         

          <div>
            <Accordion
              titulo={<div className="font-semibold">Pedidos</div>}
              opciones={
                <div>
                  <ul>
                    <Link to="/pedidos/informes">
                      <li>Informes</li>
                    </Link>
                    <Link to="/pedidos/nuevo">
                      <li>Nuevo</li>
                    </Link>
                    {/* <Link to="pedidos/aprobacion_pre_orden">
                      <li>Aprobacion</li>
                    </Link>                     */}
                    <Link to="documentos/modificar">
                      <li>Modificacion</li>
                    </Link>
                    <Link to="documentos/delete">
                      <li>Eliminacion</li>
                    </Link>
                  </ul>
                  <Accordion 
                    titulo={<div className="font-semibold text-yellow-500">Pedidos a Saldar</div>}
                    opciones={
                      <ul>
                      <Link to="inDocument">
                      <li>Informes Pedidos Saldados</li>
                    </Link>
                    <Link to="InDocument/create">
                      <li>Nuevo Pedido a Saldar</li>
                    </Link>
                    </ul>
                    }
                  />
                </div>
              }
            />
          </div>

          <div>
            <Accordion
              titulo={<div className="font-semibold">Articulos</div>}
              opciones={
                <div>
                  <ul>
                    <Link to="items/listado">
                      <li>Informes</li>
                    </Link>
                    <Link to="items/create">
                      <li>Nuevo Articulo</li>
                    </Link>
                    <Link to="items/modify">
                      <li>Modificacion</li>
                    </Link>
                  </ul>
                </div>
              }
            />
          </div>
          <div>
            <Link to="calendario">
              <div className="font-semibold">Calendario</div>
            </Link>
          </div>
          <div className="font-semibold" onClick={handleLogout}>
            <button>Salir</button>
          </div>        
        </div>      
      : 
      <div>
          <div>
            <Accordion
              titulo={<div className="font-semibold">Clientes</div>}
              opciones={
                <div>
                  <ul>
                    <Link to="clientes/listado">
                      <li>Informes</li>
                    </Link>
                    <Link to="clientes/create">
                      <li>Nuevo Cliente</li>
                    </Link>
                  </ul>
                </div>
              }
            />
          </div>
         

          <div>
            <Accordion
              titulo={<div className="font-semibold">Pedidos</div>}
              opciones={
                <div>
                  <ul>
                    <Link to="/pedidos/informes">
                      <li>Informes</li>
                    </Link>
                    <Link to="/pedidos/nuevo">
                      <li>Nuevo</li>
                    </Link>
                    {/* <Link to="pedidos/aprobacion_pre_orden">
                      <li>Aprobacion</li>
                    </Link>                     */}
                    <Link to="documentos/modificar">
                      <li>Modificacion</li>
                    </Link>
                    <Link to="documentos/delete">
                      <li>Eliminacion</li>
                    </Link>
                  </ul>
                  <Accordion 
                    titulo={<div className="font-semibold text-yellow-500">Pedidos a Saldar</div>}
                    opciones={
                      <ul>
                      <Link to="inDocument">
                      <li>Informes Pedidos Saldados</li>
                    </Link>
                    <Link to="InDocument/create">
                      <li>Nuevo Pedido a Saldar</li>
                    </Link>
                    </ul>
                    }
                  />
                </div>
              }
            />
          </div>

          <div>
            <Accordion
              titulo={<div className="font-semibold">Articulos</div>}
              opciones={
                <div>
                  <ul>
                    <Link to="items/listado">
                      <li>Informes</li>
                    </Link>
                    <Link to="items/create">
                      <li>Nuevo Articulo</li>
                    </Link>
                    <Link to="items/modify">
                      <li>Modificacion</li>
                    </Link>
                  </ul>
                </div>
              }
            />
          </div>
          <div>
            <Link to="calendario">
              <div className="font-semibold">Calendario</div>
            </Link>
          </div>

          <div>
            <Accordion
              titulo={<div className="font-semibold">Usuarios</div>}
              opciones={
                <div>
                  <ul>
                    <Link to="users">
                      <li>Informes</li>
                    </Link>
                    <Link to="/users/create">
                      <li>Nuevo Usuario</li>
                    </Link>
                  </ul>
                </div>
              }
            />
          </div>

          <div>
            <Accordion
              titulo={<div className="font-semibold">Presupuestos</div>}
              opciones={
                <div>
                  <ul>
                    <Link to="presupuestos">
                      <li>Informes</li>
                    </Link>
                    <Link to="presupuestos/nuevo">
                      <li>Nuevo</li>
                    </Link>
                    <Link to="presupuestosPrueba">
                      <li>Informes Prueba</li>
                    </Link>
                    <Link to="/precios">
                      <li>Valores</li>
                    </Link>                    
                  </ul>
                </div>
              }
            />
          </div>  
          <div className="font-semibold" onClick={handleLogout}>
            <button>Salir</button>
          </div>
        </div>      
      }     
      </div>    
  );
}
